import axios from "axios";

export default {
    namespaced: true,
    state: {
        all: [],
    },

    actions: {
        index({ commit }) {
            return axios.get(process.env.VUE_APP_API_URL + 'water-absorbent-tank-aeration')
                .then(({ data }) => {
                    commit('setWaterAbsorbentTankAerations', data);
                });
        },
    },
    getters: {
        getWaterAbsorbentTankAerationById: (state,getters) => (id) => {
            let waterabsorbenttankaerations = state.all.filter(waterAbsorbentTankAeration => {
                return waterAbsorbentTankAeration.id === id;
            });
            return waterabsorbenttankaerations !== null ? waterabsorbenttankaerations[0] : null;
        },
    },
    mutations: {
        setWaterAbsorbentTankAerations(state, waterabsorbenttankaerations) {
            state.all = waterabsorbenttankaerations;
        },
    },
}